// extracted by mini-css-extract-plugin
export default {"row":"ClientVariableRow_row__UDWgx","actions":"ClientVariableRow_actions__RJ5IJ","btnImg":"ClientVariableRow_btnImg__NsGLx"};